import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import { startPageApi } from "../api/startPageApi";
import type { StartPageTile } from "../StartPage.types";

function useStartPageTiles(projectId?: string) {
  const { data, error, isLoading } = useQuery({
    queryKey: startPageApi.tiles.key(projectId),
    queryFn: () => fetchStartPageTiles(projectId)
  });

  return {
    tiles: data,
    isLoading,
    error
  };
}

async function fetchStartPageTiles(projectId?: string) {
  const response = await apiWithoutCamelization.get<Array<StartPageTile>>(
    startPageApi.tiles.url(projectId)
  );

  return response.data;
}

export { useStartPageTiles };
